<template>
    <div class="message-item__content--text">
        <div class="content-wrap">
            <p ref="text"
                @click="clickLink"
                :class="{
                    'text': true,
                    'is-expand': isService && isBeyoungLimitLine && isExpand,
                    'is-retract': isService && isBeyoungLimitLine && !isExpand,
                    'acolor': showcolor
                }"
                :style="{background: !isService && color, color: !isService && textColor}"
                v-html="strToHtml(content)"></p>
            <div
                v-if="isService && isBeyoungLimitLine"
                class="expand-btn"
                @click.stop="toggleExpand">
                {{isExpand ? '查看全部' : '收起'}}
            </div>
        </div>
    </div>
</template>

<script>
    import expand from '../../mixins/expand'
    import { MESSAGE_NAME } from '@/constants/message'
    import { sendMessage } from '@/utils/message_send'

    export default {
        name: 'MessageContentText',
        mixins: [
            expand
        ],
        props: {
            content: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            },
            server: {
                type: Object
            }
        },
        computed: {
            showcolor () {
                if (this.server && this.server.from) {
                    if (this.server.from == 'robot' || this.server.from == 'user') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            },
            textColor () {
                if (this.theme === 'white') {
                    return '#fff'
                }
                return '#001816'
            }
        },
        methods: {
            clickLink (event) {
                if (event.target.tagName === 'A') {
                    event.stopPropagation()
                }
                else if (event.target.className.includes('is-link')) {
                    this.sendMessage(event.target.innerText)
                }
            },
            // 标签替换
            strToHtml (str) {
                // str = str.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>')
                // eslint-disable-next-line
                const match  = str.match(/&lt;click&gt;([^(&lt;click&gt;|&lt;\/click&gt;)]*?)&lt;\/click&gt;/g)
                match && match.forEach(x => {
                    const con = x.replace(/^&lt;click&gt;/, '').replace(/&lt;\/click&gt;$/, '')
                    str = str.replace(x, `<span class="is-link"> ${con} </span>`)
                })
                return str
            },
            sendMessage (content) {
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content
                })
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/content_text";

    .message-item--user {
        .text {
            color: #001816;
            background-color: $primary-color;
            @include radius(.5, .25, .5, .5);

            &:active {
                background-color: $primary-color-darken-bg;
            }
        }
    }

    .message-item--service {
        .text {
            color: $primary-text-color;
            background-color:  #ffffff;
            box-shadow: $primary-box-shadow;
            @include radius(.25, .5, .5, .5);

            &:active {
                background-color: darken(#ffffff, 7%);
            }
        }

        // 带有评价的text
        .text-has-evaluation {
            .text {
                min-width: 120px;
                @include radius(.25, .5, .5, .5);
            }
            .expand-btn {
                @include radius(0, 0, 0, 0);
            }
        }
    }

    .content-wrap {
        position: relative;
        /deep/.is-link {
            cursor: pointer;
            color: #0068FF;
            &:hover{
                color:#0068FF;
            }
        }
    }
    /deep/ a{
        color: #fff;
        &:hover{
            color:#fff;
        }
    }
    .acolor {
        /deep/ a{
            color: #0068FF;
            &:hover{
                color:#0068FF;
            }
        }
    }
</style>

